import React from 'react';
import { Header } from '@/components';
import { LoginHero } from '@/features/user/components/login';

const LoginPage: React.FC = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <LoginHero />
    </div>
  );
};

export default LoginPage;
